import state from '@/vuex/autuacao/state.js'
import getters from '@/vuex/autuacao/getters.js'
import mutations from '@/vuex/autuacao/mutations.js'
import actions from '@/vuex/autuacao/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
